import { SubwayLineGroup} from '@/pages/Home/types';
import { atom } from 'recoil';
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();


export const subwayLine = atom<SubwayLineGroup[]>({
    key: 'subwayLine',
    default: [],
    effects_UNSTABLE:[persistAtom]
});

